import React, { useEffect, useState } from "react";

export const DeleteModal = ({ text, onDelete, isLoading }) => {
	return (
		<div className="modal fade px-0" id="deleteDeclaration" aria-labelledby="deleteDeclarationLabel" aria-hidden="true">
			<div className="modal-dialog px-2">
				<div className="modal-content">
					<div className="modal-header">
						<div className="alert bg-alert-danger rounded-bottom-right-sm rounded-top-left-sm w-100 text-center mb-0">
							<h1 className="sr-only visually-hidden">Supprimer</h1>
							<div className="flex-row align-items-center justify-content-between">
								<div className="h4 font-weight-demi text-danger text-uppercase mb-0 ls-n1 lh-1 mx-auto" id="deleteDeclarationLabel">
									{text.title}
								</div>
								<button type="button" className="btn btn-close btn-icon p-0 mr-0" data-dismiss="modal" aria-label="Close">
									<i className="eva eva-close fs-4"></i>
								</button>
							</div>
						</div>
					</div>
					<div className="modal-body text-center">
						<div className="fs-sm ls-n1">
							Etes-vous sûr(e) de vouloir supprimer <strong>{text.body}</strong>?
						</div>
						<div className="fs-3 o-60">Cette action est irréversible.</div>
					</div>
					<div className="modal-footer justify-content-center">
						<button type="button" className="btn btn-faded" data-dismiss="modal" aria-label="Close">
							Annuler
						</button>
						{isLoading ? (
							<button type="button" className="btn btn-danger loading-btn px-md-gutter px-4 show">
								Supprimer<div className="loading loading-spinner spinner-border spinner-border-sm ml-2 mr-n1"></div>
							</button>
						) : (
							<button type="button" className="btn btn-danger" onClick={onDelete}>
								Supprimer
							</button>
						)}
					</div>
				</div>
			</div>
		</div>
	);
};
